<p-dialog header="Prescription" *ngIf="displayModel" [(visible)]="displayModel" [modal]="true"
    [contentStyle]="{'overflow':'scroll'}" styleClass="p-dialog-width" [baseZIndex]="10000" [draggable]="false"
    id="prescription" [resizable]="false" (onHide)="CloseDialog()" [style]="{'width':'80%'}">
    <div class="col-md-12">
        <ng-container
            *ngIf="this.prescriptionApiResult.PromiseResult.success && this.prescriptionData.consultation.p_prescriptions.length > 0">
            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button>

            <app-prescription-details [patient_id]="this.member" [data]="prescriptionData"
                [dataId]='showPrescriptiond'></app-prescription-details>


        </ng-container>
        <ng-container
            *ngIf="(!this.prescriptionApiResult.PromiseResult.success) || (this.prescriptionApiResult.PromiseResult.success && this.prescriptionData.consultation.p_prescriptions.length == 0)">
            <p>Prescription not available</p>
        </ng-container>
        <h4 *ngIf="this.posting">Fetching data...</h4>
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.posting" strokeWidth="6">
        </p-progressSpinner>
    </div>
</p-dialog>
<app-prescription-details
    *ngIf="this.prescriptionApiResult.PromiseResult.success && this.prescriptionData.consultation.p_prescriptions.length > 0 && displayModel"
    [patient_id]="this.member" [data]="this.prescriptionData" [dataId]='printContent'>
</app-prescription-details>
<ng-container *ngIf="displayModel1">
    <p-dialog header="Report" [(visible)]="displayModel1" [modal]="true" [contentStyle]="{'overflow':'scroll'}"
        [style]="{width: '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
        (onHide)="CloseDialog()">

        <div *ngIf="this.doctorReportsApiResult.PromiseResult.success">

            <div class="spaces"></div>

            <app-doctorreportpdf [data]='this.doctorReportsData' [dataId]='showDoctorReports'></app-doctorreportpdf>

            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button>

        </div>

    </p-dialog>

    <div *ngIf="this.doctorReportsApiResult.PromiseResult.success">

        <div class="spaces"></div>

        <app-doctorreportpdf [data]='this.doctorReportsData' [dataId]='printContent'></app-doctorreportpdf>

    </div>

</ng-container>


<div class="card card-w-title">
    <div class="ui-g">
        <div class="ui-md-4 statdropdown">
            <div>
                <label for="dropdown"><b>Status</b></label>
            </div>
            <p-dropdown id="dropdown" [disabled]="this.createUser1.create_api_result.Posting" [filter]="true"
                [options]="this.createUser1.other_user_list.status" [filterBy]='"label"'
                [(ngModel)]="this.createUser1.other_user_list.query.status" (onChange)="getVendorPatientList(null)">
            </p-dropdown>
        </div>
        <div class="ui-md-4 statdropdown" *ngIf="this.createUser1.other_user_list.is_support_role">
            <div>
                <label for="dropdown"><b>Vendor</b></label>
            </div>
            <p-dropdown id="dropdown" [disabled]="this.createUser1.create_api_result.Posting" [filter]="true"
                [options]="this.createUser1.other_data.vendor_list" [filterBy]='"label"'
                [(ngModel)]="this.createUser1.other_user_list.query.vendor_guid"
                (onChange)="getVendorPatientList(null)">
            </p-dropdown>
        </div>

    </div>
    <div class="ui-g">
        <div class="ui-md-2">
            <div>
                <label for="dropdownfilter"><b>Filter</b></label>
            </div>
            <p-dropdown id="dropdownfilter" [disabled]="this.createUser1.create_api_result.Posting" [filter]="true"
                [options]="this.dropdownOptions" [filterBy]='"label"'
                [(ngModel)]="this.createUser1.other_user_list.query.filter_key">
            </p-dropdown>
        </div>
        <div class="ui-md-2">
            <div>
                <label for="filter_text" class="lvisib"><b>Filter Text</b></label>
            </div>
            <input type="text" pInputText name="filter_text" id="filter_text" placeholder="Type here"
                [disabled]="this.createUser1.create_api_result.Posting"
                [(ngModel)]=" this.createUser1.other_user_list.query.filter_value">
        </div>
        <div class="ui-md-1"></div>
        <div class="ui-md-2">
            <div>
                <label for="" class="lvisib"><b>Search</b></label>
            </div>
            <button pButton type="submit" label="Search" (click)="getVendorPatientList(null)"
                [disabled]="this.createUser1.create_api_result.Posting" style="width:140px;padding:3px;"
                icon="pi pi-chevron-right" iconPos="right"></button>
        </div>
        <div class="ui-md-2">
            <div>
                <label for="" class="lvisib"><b>Reset</b></label>
            </div>
            <button pButton type="submit" label="Reset" [disabled]="this.createUser1.create_api_result.Posting"
                style="width:140px;color:#004aad;background-color: white;padding:3px;"
                (click)="this.InitFilter(true)"></button>
        </div>
    </div>
    <div class="ui-g">
        <div class="ui-md-2">
            <div>
                <label for="" class="lvisib"><b>Disable Dates?</b></label>
            </div>
            <p-checkbox [(ngModel)]="this.createUser1.other_user_list.disabledDates"
                [disabled]="this.createUser1.create_api_result.Posting"
                (onChange)=" this.createUser1.other_user_list.query.from_date=null;  this.createUser1.other_user_list.query.to_date=null; getVendorPatientList(null)"
                [binary]="true"></p-checkbox>
            <label style="padding-left:3px;font-style:bold">Disable Dates?</label>
        </div>
        <div class="ui-md-3">
            <div>
                <label for=""><b>From</b></label>
            </div>
            <p-calendar [showIcon]="true" class="notranslate"
                [disabled]="this.createUser1.other_user_list.disabledDates ||this.createUser1.create_api_result.Posting"
                [maxDate]="this.createUser1.other_user_list.maxDate" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy"
                [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2099"
                [(ngModel)]=" this.createUser1.other_user_list.query.from_date"
                (ngModelChange)="getVendorPatientList(null)"></p-calendar>
        </div>
        <div class="ui-md-3">
            <div>
                <label for=""><b>To</b></label>
            </div>
            <p-calendar [showIcon]="true" class="notranslate"
                [disabled]="this.createUser1.other_user_list.disabledDates || this.createUser1.create_api_result.Posting"
                [minDate]=" this.createUser1.other_user_list.query.from_date"
                [maxDate]="this.createUser1.other_user_list.maxDate" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy"
                [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2099"
                [(ngModel)]=" this.createUser1.other_user_list.query.to_date"
                (ngModelChange)="getVendorPatientList(null)"></p-calendar>
        </div>
        <div class="ui-md-2" *ngIf="this.createUser1.other_user_list.is_support_role">
            <div>
                <label for="" class="lvisib"><b>Filter</b></label>
            </div>
            <button pButton type="submit" label="Create Request" icon="pi pi-plus" (click)="createuser()"
                [disabled]="this.createUser1.create_api_result.Posting"
                style="margin-bottom:10px;margin-right:5px;width:165px;padding:3px;" iconPos="right"></button>
        </div>
        <div class="ui-md-2">
            <div>
                <label for="" class="lvisib"><b>Filter</b></label>
            </div>
            <button pButton type="submit" label="Download CSV" icon="pi pi-download" (click)="getDownloadData()"
                [disabled]="this.createUser1.create_api_result.Posting"
                style="width:160px;color:#004aad;background-color: white;padding:3px;" iconPos="right"></button>
        </div>
        <div class="ui-g-12" style="color: red;" *ngIf="this.createUser1.other_user_list.invalid_date_message">
            <p>Please select the From date and To date</p>
            <p-progressSpinner [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                *ngIf="this.createUser1.create_api_result.Posting" strokeWidth="6"></p-progressSpinner>
        </div>
    </div>


</div>

<div>
    <div class="table-responsive text-center justify-content-center"
        style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
        <p-table #vendorlist [value]=" this.createUser1.other_user_list.VendorDataList" [scrollable]="true" dataKey="id"
            styleClass="p-datatable-customers" [loading]="this.createUser1.loading" [lazy]="true"
            [rows]=" this.createUser1.other_user_list.query.records_per_page"
            [totalRecords]="this.createUser1.other_user_list.total_records" (onLazyLoad)="getVendorPatientList($event)"
            [paginator]="true" [showCurrentPageReport]="true" [scrollable]="true"
            [(first)]=" this.createUser1.other_user_list.query.first" [scrollable]="true" [autoLayout]="true"
            [rowsPerPageOptions]="[10,25,50]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="header">
                <tr class="trentry">
                    <th style="width: 70px;" pSortableColumn="sr_no"><b>Sr No</b></th>

                    <th pSortableColumn="name"><b>Name</b></th>

                    <th pSortableColumn="phone_number"><b>Phone</b></th>

                    <th pSortableColumn="phone_number"><b>Mailing Address</b></th>

                    <th pSortableColumn="policy_no"><b>Policy Number</b></th>

                    <th pSortableColumn="booking_id"><b>Booking Id(CRN No.)</b></th>

                    <th pSortableColumn="booking_id"><b>Consultation Type</b></th>

                    <th pSortableColumn="vendor" *ngIf="this.createUser1.other_user_list.is_support_role"><b>Vendor
                            Name</b></th>

                    <th pSortableColumn="dob"><b>Date of Birth</b></th>

                    <th pSortableColumn="gender"><b>Gender</b></th>

                    <th pSortableColumn="email"><b>Email</b></th>

                    <th pSortableColumn="doctor_assigned" *ngIf="this.createUser1.other_user_list.is_support_role">
                        <b>Doctor Assigned</b>
                    </th>

                    <th pSortableColumn="slot_booked" *ngIf="this.createUser1.other_user_list.is_support_role"><b>Slot
                            Booked</b></th>

                    <th pSortableColumn="con_req_no" *ngIf="this.createUser1.other_user_list.is_support_role">
                        <b>Consultation Request Number</b>
                    </th>

                    <th pSortableColumn="status"><b>Status</b></th>

                    <th pSortableColumn="request_created"><b>Request created at</b></th>

                    <th pSortableColumn="request_created"><b>Reason</b></th>

                    <th pSortableColumn="request_created"><b>Consultation Booked on</b></th>

                    <th pSortableColumn="request_created"><b>Consultation Date</b></th>

                    <th pSortableColumn="request_created"><b>Consultation Closed Date</b></th>

                    <th pSortableColumn="error_msg" *ngIf="this.createUser1.other_user_list.is_support_role"><b>Error
                            Message</b></th>

                    <th pSortableColumn=""><b>View</b></th>

                    <th pSortableColumn="" *ngIf="this.createUser1.other_user_list.is_support_role"><b>Consent Update</b></th>

                    <th *ngIf=" this.createUser1.other_user_list.is_support_role" pSortableColumn=""><b>Book
                            Consultation</b></th>
                    <th pSortableColumn=""><b><span *ngIf="this.createUser1.other_user_list.is_support_role">Upload
                                Documents</span><span *ngIf="!this.createUser1.other_user_list.is_support_role">View
                                Documents</span></b></th>
                    <th pSortableColumn="reports" style="font-weight: bold;">Reports</th>
                    <th pSortableColumn="prescriptions" style="font-weight: bold;">Prescriptions</th>
                </tr>

            </ng-template>

            <ng-template pTemplate="body" let-user>

                <tr [pSelectableRow]="user">

                    <td style="width: 70px;">
                        <span>{{user.sr_no}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.name}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.primary_contact_number}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.address}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.policy_no}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.booking_id_no}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.consultation_type_name}}</span>
                    </td>
                    <td style="word-wrap: break-word;" *ngIf="this.createUser1.other_user_list.is_support_role">
                        <span>{{user.vendor_name}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.date_of_birth}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.gender}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.e_email}}</span>
                    </td>
                    <td style="word-wrap: break-word;" *ngIf="this.createUser1.other_user_list.is_support_role">
                        <span>{{user.doctor_assigned}}</span>
                    </td>
                    <td style="word-wrap: break-word;" *ngIf="this.createUser1.other_user_list.is_support_role">
                        <span> {{user.slots_assigned}}</span>
                    </td>
                    <td style="word-wrap: break-word;" *ngIf="this.createUser1.other_user_list.is_support_role">
                        <span> {{user.consultation_request_number}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.status}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.created_at}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.condition_description}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.consultation_created_at}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.consultation_date}}</span>
                    </td>
                    <td style="word-wrap: break-word;">
                        <span>{{user.consultation_closed_date}}</span>
                    </td>
                    <td style="word-wrap: break-word;" *ngIf="this.createUser1.other_user_list.is_support_role">
                        <span>{{user.error_msg}}</span>
                    </td>

                    <td style="word-wrap: break-word;">
                        <span *ngIf="this.createUser1.other_user_list.is_support_role"><p-button type="button"
                            [routerLink]="['/support/view-details', this.slug, user.req_id]"
                            label="View"></p-button></span>
                        <span *ngIf="!this.createUser1.other_user_list.is_support_role"><p-button type="button"
                            [routerLink]="['/vendor/view-details', this.slug, user.req_id]"
                            label="View"></p-button></span>
                    </td>
                    <td *ngIf="this.createUser1.other_user_list.is_support_role">
                        <button pButton type="button" icon="pi pi-info-circle" (click)="showDialog(user)"></button>
                    </td>
                    <td  *ngIf=" this.createUser1.other_user_list.is_support_role">
                        <span *ngIf="user.status == 'CONSULTATION NOT BOOKED';else not_availaible"><p-button
                                type="button" (click)="bookappointment(user)"
                                label="Book Consultation"></p-button></span>
                        <ng-template #not_availaible>
                            N/A
                        </ng-template>
                    </td>
                    <td>
                        <span *ngIf="this.createUser1.other_user_list.is_support_role">
                            <span *ngIf="user.status == 'CONSULTATION NOT BOOKED'">Consultation
                                not booked</span>
                            <span *ngIf="user.status != 'CONSULTATION NOT BOOKED'"><p-button type="button"
                                    [routerLink]="['/support/upload-documents', this.slug, user.patient_guid, user.consultation_id, this.createUser1.other_user_list.is_support_role]"
                                    label="Upload Documents"></p-button></span>
                            <!-- <span *ngIf="user.has_consented==false">Consent Pending</span> -->

                        </span>
                        <span *ngIf="!this.createUser1.other_user_list.is_support_role">
                            <span
                                *ngIf="user.status == 'CONSULTATION NOT BOOKED' && user.has_consented==true">Consultation
                                not booked</span>

                            <span *ngIf="user.status != 'CONSULTATION NOT BOOKED' && user.has_consented==true"><p-button
                                    type="button"
                                    [routerLink]="['/vendor/upload-documents', this.slug, user.patient_guid, user.consultation_id, this.createUser1.other_user_list.is_support_role]"
                                    label="View Documents"></p-button></span>
                            <span *ngIf="user.has_consented==false">Consent Pending</span>


                        </span>

                    </td>
                    <td>
                        <span *ngIf="this.createUser1.other_user_list.is_support_role">
                            <span *ngIf="user.status != 'CONSULTATION CLOSED'">Consultation
                                not closed</span>
                            <span *ngIf="user.status == 'CONSULTATION CLOSED'">
                                <p-button (click)=" gotoReportpdf(user.consultation_id,user.patient_guid)"
                                    icon="pi pi-external-link" label="View"></p-button>
                            </span>

                        </span>
                        <span *ngIf="!this.createUser1.other_user_list.is_support_role">
                            <span *ngIf="user.status != 'CONSULTATION CLOSED' && user.has_consented==true">Consultation
                                not closed</span>
                            <span *ngIf="user.status == 'CONSULTATION CLOSED' && user.has_consented==true">
                                <p-button (click)=" gotoReportpdf(user.consultation_id,user.patient_guid)"
                                    icon="pi pi-external-link" label="View"></p-button>
                            </span>
                            <span *ngIf="user.has_consented==false">Consent Pending</span>
                        </span>

                    </td>
                    <td>
                        <span *ngIf="this.createUser1.other_user_list.is_support_role">
                            <span *ngIf="user.status != 'CONSULTATION CLOSED'">Consultation
                                not closed</span>
                            <span *ngIf="user.status == 'CONSULTATION CLOSED';">
                                <p-button (click)="gotoprescription(user.consultation_id,user.patient_guid)"
                                    icon="pi pi-external-link" label="View">
                                </p-button>
                            </span>

                        </span>

                        <span *ngIf="!this.createUser1.other_user_list.is_support_role">
                            <span *ngIf="user.status != 'CONSULTATION CLOSED' && user.has_consented==true">Consultation
                                not closed</span>
                            <span *ngIf="user.status == 'CONSULTATION CLOSED' && user.has_consented==true">
                                <p-button (click)="gotoprescription(user.consultation_id,user.patient_guid)"
                                    icon="pi pi-external-link" label="View">
                                </p-button>
                            </span>
                            <span *ngIf="user.has_consented==false">Consent Pending</span>
                        </span>

                    </td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4">No Data found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
            </ng-template>
        </p-table>
        <div class="row container justify-content-center text-center ml-3 mt-3"
            *ngIf="createUser1.create_api_result.PromiseResult.success!=null && createUser1.create_api_result.PromiseResult.success==false">
            <p class="alert-danger heading4" *ngIf="createUser1.create_api_result.PromiseResult.error!=null">
                {{createUser1.create_api_result.PromiseResult.error.message}}</p>
            <div
                *ngIf="this.createUser1.create_api_result.ServerError?.error!=null && this.createUser1.create_api_result.ServerError?.statusCode!=500">
                <p class="alert-danger heading4"
                    *ngFor="let message of this.createUser1.create_api_result.ServerError?.message">{{message}}</p>
            </div>
            <div
                *ngIf="this.createUser1.create_api_result.ServerError?.error!=null && this.createUser1.create_api_result.ServerError?.statusCode==500">
                <p class="alert-danger heading4">{{this.createUser1.create_api_result.ServerError?.message}}</p>
            </div>

        </div>
    </div>
</div>


<p-dialog [(visible)]="display" header="Update Consent Status" [style]="{width: '30vw'}" [resizable]=true
    [contentStyle]="{'height': '350px' ,'overflow':'visible'}">
    <div style="margin-bottom: 10px;">
        <label style="margin-right: 105px;font-weight: bold;">Status</label>
        <p-toggleButton id="status" [(ngModel)]="this.consent_update.has_consented"
            [style]="{'width':'50%','border-radius':'50rem'}" onLabel="Consented" offLabel="Not Consented"
            [onIcon]="'pi pi-check'" offIcon="pi pi-times"></p-toggleButton>
    </div>
    <div style="margin-top: 50px;">
        <label style="margin-right: 50px;font-weight: bold;">Update</label>

        <p-button icon="pi pi-check" (click)="updateConsent()" label="Update" styleClass="p-button-text"></p-button>
        <p>{{this.update_msg}}</p>
    </div>
</p-dialog>






<h4 *ngIf="this.createUser1.create_api_result.Posting">Fetching Patients...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.createUser1.create_api_result.Posting"
    strokeWidth="6">